module.exports = __webpack_public_path__ + "static/home2-b2cdc7f423616ac80db7992cbe916f38.jpg";